import React from "react";
import {useTranslation} from "react-i18next";
import {isEmptyObject} from "../../../../../utils/helpers";
import {BarReportWidget} from "../BarReportWidget/BarReportWidget";
import {resolvePaymentType} from "../../../../../utils/resolvePaymentType";

export const PaymentMethodStatsWidget = ({data = {}, loading}) => {
    const {t} = useTranslation(["paymentMethodStatsWidget", "paymentTypes"]);
    const resolver = orderCountByPaymentType => {
        if (isEmptyObject(orderCountByPaymentType)) {
            return [];
        }

        return Object.entries(orderCountByPaymentType).map(entry => ({
            name: t(resolvePaymentType(entry[0]).translation_key, {ns: "paymentTypes"}),
            value: entry[1]
        }));
    };

    return (
        <BarReportWidget
            barColor={"#D3DEDC"}
            data={resolver(data)}
            drawLine={false}
            loading={loading}
            height={200}
            title={<h1>{t("paymetTypeTitle", {ns: "paymentMethodStatsWidget"})}</h1>}
        />
    );
};
